export enum UserLanguageEnum {
  Ko = "ko-KR",
  En = "en-US",
  Ja = "ja-JP",
}

export enum I18nEnum {
  Ko = "ko",
  En = "en",
  Ja = "ja",
}
